export namespace ThemeAssets {
  export type Assets = Assets2D | Assets3D;

  export enum Perspective {
    PIECE_PERSPECTIVE_UNSPECIFIED = 'PIECE_PERSPECTIVE_UNSPECIFIED',
    TOP_DOWN = 'TOP_DOWN',
    PSEUDO_3D = 'PSEUDO_3D',
    REAL_3D = 'REAL_3D',
  }

  export type Assets2D = {
    board: {
      config: BoardConfig2D;
      assets: BoardAssets2D;
    };
    pieces: {
      assets: PieceAssets2D;
    };
    sound: {
      assets: SoundAssets;
    };
    config: {
      perspective: Omit<Perspective, Perspective.REAL_3D>;
    };
  };

  export type BoardAssets2D = {
    background: string;
  };

  export type CoordinateColors = {
    lightSquareCoordinateHex: string;
    darkSquareCoordinateHex: string;
  };

  export type BoardConfig2D = CoordinateColors & {
    highlightSquareHex: string;
  };

  export type PieceAssets2D = {
    wk: string;
    wq: string;
    wr: string;
    wb: string;
    wn: string;
    wp: string;
    bk: string;
    bq: string;
    br: string;
    bb: string;
    bn: string;
    bp: string;
  };

  export type Assets3D = {
    board: {
      config: BoardConfig3D;
      assets: BoardAssets3D;
    };
    pieces: {
      assets: PieceAssets3D;
    };
    sound: {
      assets: SoundAssets;
    };
    config: {
      perspective: Perspective.REAL_3D;
    };
  };

  export type BoardAssets3D = {
    background: string;
    coordinates: string;
    boardModel?: string;
    boardShadow?: string;
  };

  export type BoardConfig3D = {
    highlightSquareHex: string;
  };

  export type PieceAssets3D = {
    kModel?: string;
    kShadow?: string;
    qModel?: string;
    qShadow?: string;
    rModel?: string;
    rShadow?: string;
    nModel?: string;
    nShadow?: string;
    bModel?: string;
    bShadow?: string;
    pModel?: string;
    pShadow?: string;
    lightTexture?: string;
    darkTexture?: string;
    wqPromotion?: string;
    bqPromotion?: string;
    wrPromotion?: string;
    brPromotion?: string;
    wbPromotion?: string;
    bbPromotion?: string;
    wnPromotion?: string;
    bnPromotion?: string;
  };

  export type SoundAssetFileFormat = 'webm' | 'ogg' | 'mp3' | 'wav';

  export type SoundAsset = {
    [key in SoundAssetFileFormat]?: string;
  };

  export type SoundAssets = {
    capture: SoundAsset;
    castle: SoundAsset;
    gameEnd: SoundAsset;
    gameStart: SoundAsset;
    illegal: SoundAsset;
    moveCheck: SoundAsset;
    moveOpponent: SoundAsset;
    moveSelf: SoundAsset;
    notify: SoundAsset;
    premove: SoundAsset;
    promote: SoundAsset;
    tenSeconds: SoundAsset;
  };
}
